import { render } from "./ExpiredPaymentInfo.vue?vue&type=template&id=a0a4da0a&scoped=true"
import script from "./ExpiredPaymentInfo.vue?vue&type=script&lang=js"
export * from "./ExpiredPaymentInfo.vue?vue&type=script&lang=js"

import "./ExpiredPaymentInfo.vue?vue&type=style&index=0&id=a0a4da0a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a0a4da0a"

export default script